export enum EScrollEventBlockId {
  investmentCreditPageBenefits = 'investmentCreditPageBenefits',
  investmentCreditPageAffiliation = 'investmentCreditPageAffiliation',
  investmentCreditPageStages = 'investmentCreditPageStages',
  investmentCreditPageConditions = 'investmentCreditPageConditions',
  financingOfferForm = 'financingOfferForm',
}
